import { List, useGetList } from "react-admin";
import { PageTitle } from "../../misc/PageTitle";
import type { Branch } from "../../providers/branchesProvider";
import { grants } from "../../backoffice.access_control";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { Row } from "../../misc/Row";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { ResponsiveHashTabs } from "../../misc/ResponsiveHashTabs";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { EmptyState } from "../../misc/EmptyState";
import { useCurrentDrivingSchoolId } from "../../hooks/useCurrentDrivingSchoolId";
import { BranchesDataGrid } from "./BranchesDataGrid";

export function DrivingSchoolBranches() {
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const navigate = useNavigate();
  const { data: inactiveBranches } = useGetList<Branch>("branches", {
    filter: { drivingSchoolId, isActive: false },
    pagination: { page: 1, perPage: 1 },
  });

  if (!inactiveBranches) {
    return <LoadingIndicator />;
  }

  const tabs = [
    {
      value: "",
      label: "Filialen",
      content: <_BranchesList filter={{ drivingSchoolId, isActive: true }} insideTab />,
    },
    {
      value: "inactive",
      label: "Geschlossene Filialen",
      content: <_BranchesList filter={{ drivingSchoolId, isActive: false }} insideTab />,
    },
  ];

  return (
    <div style={{ position: "relative" }}>
      <Row justifyContent="space-between" alignItems="center" sx={{ mb: "30px", minHeight: "32px" }}>
        <PageTitle documentTitle="Filialen">
          <h2 style={{ margin: 0, lineHeight: 0.83 }}>Filialen</h2>
        </PageTitle>
        {grants.has("Branch:create") && (
          <Button variant="outlined" startIcon={<AddIcon />} onClick={() => navigate("/branches/create")} size="small">
            Hinzufügen
          </Button>
        )}
      </Row>
      {inactiveBranches.length ? (
        <ResponsiveHashTabs tabs={tabs} mobileSelectAriaLabel="Filialen-Ansicht" />
      ) : (
        <_BranchesList filter={{ drivingSchoolId, isActive: true }} />
      )}
    </div>
  );
}

function _BranchesList(props: { filter: { drivingSchoolId: string; isActive: boolean }; insideTab?: boolean }) {
  const { filter, insideTab } = props;
  const empty = (
    <EmptyState
      noEntriesText={filter.isActive ? "Noch keine Filiale hinterlegt." : "Keine geschlossenen Filialen vorhanden."}
    />
  );

  return (
    <ResponsiveListSurface variant={insideTab ? "compactTabContent" : "compactStandalone"}>
      <List
        resource="branches"
        title=" "
        storeKey={`DrivingSchoolBranches-${filter.isActive ? "active" : "inactive"}@${filter.drivingSchoolId}`}
        filter={filter}
        sort={/* initial sort order: */ { field: "name", order: "ASC" }}
        actions={false}
        exporter={false}
        hasCreate={false}
        empty={empty}
      >
        <BranchesDataGrid empty={empty} isActive={filter.isActive} />
      </List>
    </ResponsiveListSurface>
  );
}
